// src/locales/en/packingBatch.js
export const packingBatch = {
  qtyPlaceholder: "Qty",
  // Page Titles
  createPackingBatch: "Create Packing Batch",
  allPackingBatches: "Packing Batches",
  packingBatchDetails: "Packing Batch Details",
  createDescription: "Create a new packing batch for warehouse processing",

  // List Page
  pageDescription: "View and manage all packing batches",
  allCourierAccounts: "All Courier Accounts",
  allStatuses: "All Statuses",
  dateRange: "Date Range",
  searchByBatchNumber: "Search by batch number...",
  noBatchesFound: "No Batches Found",
  noBatchesFoundDescription: "No batches match your search criteria",
  failedToLoadBatches: "Failed to load packing batches",
  
  // Confirmations
  confirmRetryFailed: "Are you sure you want to retry all failed orders in batch {{batchNumber}}?",
  confirmBulkRetry: "Retry failed orders in {{count}} batch(es)?",
  
  // Success/Error Messages
  retrySuccessCount: "Successfully retried {{count}} order(s)",
  noOrdersRetried: "No orders were successfully retried",
  noFailedBatchesSelected: "No batches with failed orders selected",
  bulkRetrySuccessful: "Successfully retried orders in {{count}} batch(es)",
  failedToRetrySome: "Failed to retry some batches",
  retrySelected: "Retry Selected ({{count}})",
  
  // Filters
  selectWarehouse: "Select Warehouse",
  selectCourier: "Select Courier",
  selectCourierAccount: "Select Courier Account",
  selectCourierRule: "Select Courier Assignment Rule",
  allOrders: "All Orders",
  selectStatuses: "Select Statuses",
  allShops: "All Shops",
  allCities: "All Cities",
  allProducts: "All Products",
  searchOrders: "Search Orders",
  courierRule: "Courier Assignment Rule",
  courierAccount: "Courier Account",
  warehouse: "Warehouse",
  orderStatus: "Order Status",
  products: "Products",
  advancedFilters: "Advanced Filters",
  showAdvanced: "Show Advanced Filters",
  hideAdvanced: "Hide Advanced Filters",
  searchPlaceholder: "Order number, customer name, or phone...",
  
  // Table Headers
  orderNumber: "Order #",
  order: "Order",
  customerName: "Customer",
  customer: "Customer",
  phoneNumber: "Phone",
  shop: "Shop",
  city: "City",
  paymentType: "Payment Type",
  payment: "Payment",
  status: "Status",
  grandTotal: "Total",
  total: "Total",
  itemsPreview: "Items",
  items: "Items",
  airwaybillNumber: "Airwaybill Number",
  
  // Batch Creation
  selectedOrders: "Selected Orders",
  selected: "Selected",
  totalValue: "Total Value",
  notes: "Notes",
  notesPlaceholder: "Add any notes about this batch...",
  createBatch: "Create Packing Batch",
  clearSelection: "Clear Selection",
  account: "Account",
  
  // Progress
  creatingBatch: "Creating Packing Batch",
  processingOrder: "Processing order",
  of: "of",
  processing: "Processing",
  success: "Success",
  failed: "Failed",
  creating: "Creating...",
  searching: "Searching...",
  retrying: "Retrying...",
  adding: "Adding...",
  
  // Results
  batchCreatedSuccessfully: "Batch Created Successfully",
  batchNumber: "Batch Number",
  batchNumberTitle: "Batch #{{number}}",
  totalOrders: "Total Orders",
  successfulOrders: "Successful",
  failedOrders: "Failed",
  viewBatchDetails: "View Batch Details",
  createAnotherBatch: "Create Another Batch",
  printAirwaybills: "Print Airwaybills",
  
  // Messages
  noEligibleOrders: "No eligible orders found",
  selectWarehouseFirst: "Please select a warehouse",
  selectCourierFirst: "Please select a courier company",
  selectAtLeastOneOrder: "Please select at least one order",
  batchCreationFailed: "Failed to create packing batch",
  searchFailed: "Failed to search orders",
  loadBatchError: "Failed to load batch details",
  noFailedOrders: "No failed orders to retry",
  retryCompleted: "Failed orders retry completed",
  retryError: "Failed to retry orders",
  searchOrdersError: "Failed to search eligible orders",
  ordersAddedSuccess: "Added {{count}} orders successfully",
  addOrdersError: "Failed to add orders to batch",
  largeBatchConfirm: "You are about to create a batch with {{count}} orders. This may take a while. Continue?",
  retryConfirm: "Retry {{count}} failed order(s)?",
  
  // Validation
  warehouseRequired: "Warehouse is required",
  courierRequired: "Courier company is required",
  ordersRequired: "At least one order is required",
  
  // Status
  inProgress: "In Progress",
  completed: "Completed",
  partiallyFailed: "Partially Failed",
  statusPartiallyfailed: "Partially Failed",
  statusCompleted: "Completed",
  statusInProgress: "In Progress",
  statusPartiallyFailed: "Partially Failed",
  statusFailed: "Failed",
  
  // Actions
  viewAllBatches: "View All Batches",
  retryFailed: "Retry Failed Orders",
  retryFailedOrders: "Retry Failed Orders",
  retryAll: "Retry All",
  addOrders: "Add Orders",
  viewOrder: "View Order",
  copyAirwaybill: "Copy airwaybill",
  
  // Batch Info
  createdBy: "Created By",
  createdAt: "Created At",
  created: "Created",
  by: "by",
  batchStatus: "Status",
  
  // Empty States
  noBatchesYet: "No batches yet",
  createFirstBatch: "Create your first packing batch",
  noOrdersFound: "No orders found",
  adjustFilters: "Try adjusting your filters",
  noMatchingFilters: "No orders match your current filters",
  eligibleOrders: "Eligible Orders ({{count}})",
  
  // Batch List
  batchManagement: "Batch Management",
  filterByDate: "Filter by Date",
  filterByWarehouse: "Filter by Warehouse",
  filterByCourier: "Filter by Courier",
  filterByStatus: "Filter by Status",
  searchByBatchNumber: "Search by Batch Number",
  applyFilters: "Apply Filters",
  resetFilters: "Reset Filters",
  
  // Statistics
  totalBatches: "Total Batches",
  totalOrdersProcessed: "Total Orders Processed",
  totalValueProcessed: "Total Value Processed",
  successRate: "Success Rate",
  
  // Batch Actions
  viewDetails: "View Details",
  exportBatch: "Export Batch",
  printBatch: "Print Batch",
  backToBatches: "Back to Batches",
  batchNotFound: "Batch not found",
  loadingBatch: "Loading batch details...",
  
  // Batch Details
  ordersInBatch: "Orders in Batch ({{count}})",
  searchOrdersPlaceholder: "Search orders...",
  allStatus: "All Status",
  showAll: "Show All",
  failedOnly: "Failed Only",
  addOrdersToBatch: "Add Orders to Batch",
  searchEligiblePrompt: "Search for eligible orders to add to this batch",
  addOrdersCount: "Add {{count}} Order(s)",
  addingOrders: "Adding Orders to Batch",
  selectPrintFormat: "Select Print Format",
  labelFormat: "102mm × 76mm Label",
  labelFormatDesc: "For thermal label printers",
  a4Format: "A4 (4 per page)",
  a4FormatDesc: "For standard office printers",
  a4FormatLandscape: "A4 Landscape (4 per page)",
  a4FormatLandscapeDesc: "A4 paper with 4 waybills - Landscape",
  
  // Counts/Formatting
  ordersCount: "{{count}} orders",
  itemsCount: "{{count}} items",

  labelFormatVertical: "102mm × 76mm Vertical",
  labelFormatHorizontal: "102mm × 76mm Horizontal",
  labelFormatHorizontalQr: "102mm × 76mm Horizontal (Long AWB + QR)",
  labelFormatHorizontalQrDesc: "For couriers with long airwaybill numbers — includes full-width barcode and QR code",
  labelFormatHorizontalExtended: "102mm × 76mm Horizontal (Extended)",
  labelFormatHorizontalExtendedDesc: "Shows up to 7 items, exchange badge and return waybill",

  // Print Status
  printed: "Printed",
  notPrinted: "Not Printed",
  printedAt: "Printed at",
  printedBy: "Printed by",
  markPrintedError: "Failed to record print status",

  // Product List View
  productListTitle: "Product List ({{count}})",
  viewOrdersTab: "Orders",
  viewProductsTab: "Products",
  searchProductsPlaceholder: "Search products...",
  productColumn: "Product",
  skuColumn: "SKU",
  totalQuantityColumn: "Total Quantity",
  orderCountColumn: "Orders",
  loadingProductList: "Loading product list...",
  noProductsFound: "No products found",
  noProductsFoundDescription: "No products match your current filters",
  loadProductListError: "Failed to load product list",
  printProductList: "Print",
  exportExcel: "Excel",
  exportPdf: "PDF",
  productListPrintSubtitle: "Product Pick List",

  // Channel
  channel: "Channel",
  channelOnline: "Online",
  channelOffline: "Offline",
  productListPrintTitle: "Product List — Batch #{{number}}",
  productListReceiptTitle: "Product List",
  productListBatchLabel: "Batch",
  productListPrintedOn: "Printed On",
  receiptTotalProducts: "Total Products",
  receiptTotalQuantity: "Total Quantity",
};

// Courier Upload Format translations
export const courierUpload = {
  // Page Titles
  title: "Courier Upload Format Generator",
  pageTitle: "Courier Upload Format Generator",
  subtitle: "Generate courier-specific upload files for dispatched orders",
  pageDescription: "Generate courier-specific upload files for dispatched orders",
  
  // Tabs
  byPackingBatch: "By Packing Batch",
  byDateCourier: "By Date & Courier",
  byDateAndCourier: "By Date & Courier",
  
  // Tooltips
  batchTooltip: "Generate upload file for all orders in a specific packing batch",
  byPackingBatchTooltip: "Generate upload file for all orders in a specific packing batch",
  dateTooltip: "Generate upload file for orders dispatched on a specific date for a courier",
  byDateAndCourierTooltip: "Generate upload file for orders dispatched on a specific date for a courier",
  
  // Filters
  selectPackingBatch: "Select Packing Batch",
  selectCourierAccount: "Select Courier Account",
  dispatchedDate: "Dispatched Date",
  courierAccount: "Courier Account",
  packingBatch: "Packing Batch",
  
  // Actions
  generatePreview: "Generate Preview",
  generating: "Generating...",
  clear: "Clear",
  viewPdf: "View PDF",
  downloadPdf: "Download PDF",
  pdfTitle: "Dispatched Orders",
  companyName: "Company Name",
  courierCompanyLabel: "Courier Company",
  courierRepresentative: "Courier Representative",
  dateLabel: "Date",
  timeLabel: "Time",
  dispatchConfirmText: "We confirm that the following parcels have been dispatched and handed over to the courier representative for delivery.",
  totalParcels: "Total Parcels",
  totalCodAmount: "Total COD Amount",
  dispatchConfirmation: "Dispatch Confirmation",
  parcelCollectionConfirmation: "Parcel Collection Confirmation",
  name: "Name",
  signature: "Signature",
  nameCourier: "Name (Courier)",
  signatureCourier: "Signature (Courier)",
  generatedOn: "Generated on",
  colNo: "#",
  colWaybill: "Waybill Id",
  colOrderNo: "Order No.",
  colCity: "City",
  colCod: "COD",
  pdfDownloadSuccess: "PDF downloaded successfully",
  pdfDataMissing: "PDF data is not available. Please restart the backend server and generate the preview again.",
  pdfDownloadError: "Failed to download PDF",
  downloadExcel: "Download Excel",
  downloadCSV: "Download CSV",
  
  // Summary
  courierCompany: "Courier Company",
  businessAccount: "Business Account",
  mappingFormat: "Mapping Format",
  totalOrders: "Total Orders",
  generatedAt: "Generated At",
  
  // Preview
  dataPreview: "Data Preview",
  showing: "Showing",
  showingRange: "Showing {{from}} to {{to}} of {{total}} orders",
  to: "to",
  of: "of",
  orders: "orders",
  ordersCount: "{{count}} orders",
  page: "Page",
  previous: "Previous",
  next: "Next",
  
  // Empty State
  noDataGenerated: "No Data Generated",
  emptyStateMessage: "Select a packing batch or courier account and date to generate upload format",
  selectToGenerate: "Select a packing batch or courier account and date to generate upload format",
  
  // Messages
  selectBatchFirst: "Please select a packing batch",
  selectCourierDateFirst: "Please select courier account and date",
  selectCourierAndDate: "Please select courier account and date",
  excelDownloaded: "Excel file downloaded successfully",
  excelDownloadSuccess: "Excel file downloaded successfully",
  csvDownloaded: "CSV file downloaded successfully",
  csvDownloadSuccess: "CSV file downloaded successfully",
  failedToGenerate: "Failed to generate preview",
  generateError: "Failed to generate preview",
  failedToDownload: "Failed to download file",
  excelDownloadError: "Failed to download Excel file",
  csvDownloadError: "Failed to download CSV file",
  loadRefDataFailed: "Failed to load reference data",
  
  // Additional fields
  ordersSheet: "Orders",
  batchOption: "Batch #{{id}} - {{courier}} - {{date}} ({{orders}} orders)",
  batchNumber: "Batch #{{id}}",
};

// Dispatch translations
export const dispatch = {
  // Page Titles
  pageTitle: "Dispatch Orders",
  pageDescription: "Scan barcode to dispatch orders",
  
  // Statistics
  todayDispatches: "Today's Dispatches",
  todayValue: "Today's Value",
  thisSession: "This Session",
  
  // Scan Section
  scanToDispatch: "Scan to Dispatch",
  orderIdentifier: "Order Identifier",
  identifierPlaceholder: "Scan barcode or enter order/airwaybill number...",
  dispatchDate: "Dispatch Date",
  pastDatesNotAllowed: "Past dates not allowed",
  backdatedDispatch: "This is a backdated dispatch",
  
  // Actions
  dispatchOrder: "Dispatch Order",
  processing: "Processing...",
  dispatchBatch: "Dispatch Batch",
  dispatching: "Dispatching...",
  confirmDispatch: "Dispatch {{count}} Orders",
  
  // Messages
  enterIdentifier: "Please enter an order identifier",
  dispatchSuccess: "Order {{orderNumber}} dispatched successfully",
  dispatchFailed: "Dispatch Failed",
  successfullyDispatched: "Successfully Dispatched!",
  noOrdersToDispatch: "No orders available to dispatch",
  batchDispatchSuccess: "Successfully dispatched {{count}} orders",
  
  // Order Details
  orderNumber: "Order Number",
  airwaybill: "Airwaybill",
  customer: "Customer",
  status: "Status",
  totalAmount: "Total Amount",
  codAmount: "COD Amount",
  location: "Location",
  phone: "Phone",
  dispatched: "Dispatched",
  dispatchedOrders: "Dispatched Orders",
  
  // Keyboard Shortcuts
  keyboardShortcuts: "Keyboard Shortcuts",
  focusInput: "Focus input field",
  submitScan: "Submit scan",
  clearForm: "Clear form",
  
  // Recent Dispatches
  recentDispatches: "Recent Dispatches",
  noDispatchesYet: "No dispatches in this session yet",
  dispatchesWillAppear: "Dispatched orders will appear here",
  
  // Order Selection
  selectOrdersToDispatch: "Select Orders to Dispatch",
  selectedOrdersCount: "{{selected}} of {{total}} orders selected",
};

// Print translations
export const print = {
  pageTitle: "Print Airwaybills",
  batchNumber: "Batch #{{number}}",
  labelsCount: "{{count}} Labels",
  printLabels: "Print Labels",
  preparing: "Preparing...",
  format: "Format",
  warehouse: "Warehouse",
  courierAccount: "Courier Account",
  readyToPrint: "Ready to Print",
  loadError: "Failed to load print data",
  waitForLoad: "Please wait for the page to load completely",
  invalidFormat: "Invalid Print Format",
  formatNotSupported: "Format \"{{format}}\" is not supported",
  loadingData: "Loading print data...",
  preparingLabels: "Preparing labels",
  noDataAvailable: "No Print Data Available",
  unableToLoad: "Unable to load print data for this batch",
  backToBatch: "Back to Batch",
  labelFormat: "102mm × 76mm Label",
  labelFormatVertical: "102mm × 76mm Vertical",
  labelFormatHorizontal: "102mm × 76mm Horizontal",
  a4Format: "A4 (4 per page)",
  a4FormatLandscape: "A4 Landscape (4 per page)",
  pageTitle: "Print Waybills",
  printWaybills: "Print Waybills",
  selectedOrdersLabel: "Selected Orders",
  mixedCouriers: "Mixed Couriers",
  switchFormat: "Switch Format",
  selectFormat: "Select Format",
  sortBy: "Sort By",
  sortDoNotSort: "Do not Sort",
  sortItemsDisplay: "Items Display",
  sortOrderId: "Order ID",
  sortAirwaybillNumber: "Airwaybill Number",
  labelFormatHorizontalQr: "102mm × 76mm Horizontal (Long AWB + QR)",
  labelFormatHorizontalExtended: "102mm × 76mm Horizontal (Extended)",
  labelFormatHorizontalExtendedDesc: "Shows up to 7 items, exchange badge and return waybill",
};